// src/components/Login.js
import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import "./Login.css";

// Logo URLs matching HeaderLogo.js
const LOGO_SCHLAGE_LIGHT =
  "https://yptraining.romancontrols.com/images/romanworks-trans-black.png";
const LOGO_SCHLAGE_DARK =
  "https://yptraining.romancontrols.com/images/romanworks-trans-white.png";
const LOGO_ROMANWORKS_LIGHT =
  "https://yptraining.romancontrols.com/images/romanworks-trans-black.png";
const LOGO_ROMANWORKS_DARK =
  "https://yptraining.romancontrols.com/images/romanworks-trans-white.png";

const Login = () => {
  const { login, error } = useAuth();
  const [logoSrc, setLogoSrc] = useState("");
  const [logoutReason, setLogoutReason] = useState(null);

  useEffect(() => {
    document.title = "Romanworks Real-Time Device Management App";

    // Check if user was logged out due to session expiration
    const reason = sessionStorage.getItem("logoutReason");
    if (reason === "session_expired") {
      setLogoutReason("Your session has expired. Please sign in again.");
      sessionStorage.removeItem("logoutReason");
    }

    // Get saved theme and logo preferences from localStorage
    const savedTheme = localStorage.getItem("theme") || "dark-mode";
    const savedLogo = localStorage.getItem("activeLogo") || "schlage";

    // Apply the saved theme to the body element
    document.body.className = savedTheme === "light-mode" ? "light-mode" : "";

    // Determine which logo to display based on theme and logo preference
    const isLightMode = savedTheme === "light-mode";
    const isRomanworks = savedLogo === "romanworks";

    let selectedLogo;
    if (isRomanworks) {
      selectedLogo = isLightMode ? LOGO_ROMANWORKS_LIGHT : LOGO_ROMANWORKS_DARK;
    } else {
      selectedLogo = isLightMode ? LOGO_SCHLAGE_LIGHT : LOGO_SCHLAGE_DARK;
    }

    setLogoSrc(selectedLogo);
  }, []);

  const handleLogin = () => {
    login();
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <div className="login-header">
          <div className="login-logo">
            {logoSrc && (
              <img src={logoSrc} alt="Romanworks Logo" className="logo-image" />
            )}
          </div>
          <h1>Romanworks Real-Time Device Management App</h1>
          <p className="login-subtitle">Secure access to device management</p>
        </div>

        {logoutReason && (
          <div
            className="login-error"
            style={{
              backgroundColor: "#fef3cd",
              borderColor: "#ffc107",
              color: "#856404",
            }}
          >
            <span className="login-error-icon">⏱️</span>
            <span className="login-error-message">{logoutReason}</span>
          </div>
        )}

        {error && (
          <div className="login-error">
            <span className="login-error-icon">⚠️</span>
            <span className="login-error-message">{error}</span>
          </div>
        )}

        <div className="login-body">
          <button className="login-button" onClick={handleLogin}>
            <span className="login-button-text">Sign In</span>
          </button>

          <div className="login-info">
            <p>
              By signing in, you agree to access this secure application using
              your authorized credentials.{" "}
              <a
                href="https://yptraining.romancontrols.com/romanworks-userguide"
                target="_blank"
                rel="noopener noreferrer"
              >
                Request an Account
              </a>
            </p>
          </div>
        </div>

        <div className="login-footer">
          <p className="login-footer-text">
            Powered by Allegion Yonomi Platform |{" "}
            <a
              href="https://realtime.romancontrols.com/privacy-policy.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
